module.exports = __webpack_public_path__ + "static/media/marginalia-information-security.29c70f67.svg";